import { useMemo } from 'react';
import { siteConfig } from '@/app/config/global';

export interface UseOriginalTotalPagesProperties {
  filteredRowsCount: number;
}

const useOriginalTotalPages = ({ filteredRowsCount }: UseOriginalTotalPagesProperties): number =>
  useMemo(() => Math.ceil(filteredRowsCount / siteConfig.rowsPerPageDefault), [filteredRowsCount]);

export default useOriginalTotalPages;
